import { TenantsListEnum } from '@ui-core/enums/tenants-list.enum'
import { TenantMenuItem } from '@ui-core/interfaces/menu.interface'

const TENANT_MENUS: Record<string, () => Promise<TenantMenuItem>> = {
    [TenantsListEnum.BIOCANVAS]: () =>
        import('@tenants/biocanvas/constants/menu.constant').then((m) => ({
            tenant: TenantsListEnum.BIOCANVAS,
            menu: m.MENU,
            userMenu: m.USER_MENU
        })),
    [TenantsListEnum.CUCUMBER]: () =>
        import('@tenants/cucumber/constants/menu.constant').then((m) => ({
            tenant: TenantsListEnum.CUCUMBER,
            menu: m.MENU,
            userMenu: m.USER_MENU
        })),
    [TenantsListEnum.COMVITA]: () =>
        import('@tenants/comvita/constants/menu.constant').then((m) => ({
            tenant: TenantsListEnum.COMVITA,
            menu: m.MENU,
            userMenu: m.USER_MENU
        }))
}

export { TENANT_MENUS }
